import React, { useEffect, useState, useRef, createRef } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import "antd/dist/antd.min.css";
import { debounce } from "lodash";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { createRoot } from "react-dom/client";
import { getRequest, patchRequest, postRequest } from "../../axios";
import ButtonField from "../../common/htmlComponents/ButtonField";
import {
  DownloadOutlined,
  EyeOutlined,
  InsertRowLeftOutlined,
  UndoOutlined,
  FilterOutlined,
} from "@ant-design/icons";
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Dropdown,
  Form,
  Input,
  Menu,
  Popconfirm,
  Row,
  Space,
  Table,
  Tooltip,
  Select,
  Tag,
  DatePicker,
} from "antd";
import { ReactComponent as Archive } from "../../image/Archive.svg";
import { ReactComponent as ArchiveButtonicon } from "../../image/ArchiveButtonicon.svg";

import { ReactComponent as Archiveicon } from "../../image/Archiveicon.svg";
import { ReactComponent as Editicon } from "../../image/Editicon.svg";
import PlusSquareOutlined from "../../image/PlusSquareOutlined.svg";
import SearchIcon from "../../image/SearchIcon.svg";
import "../../styles/Main.scss";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import { authUserData } from "../../utils/Helper";
import { confirmAlert } from "react-confirm-alert";
import moment from "moment";

import AdjustmentInvoicePdf from "../invoice/AdjustmentInvoicePdf";

const AdjustmentListAdmin = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const formRef = useRef();
  const navigate = useNavigate();
  const { Option } = Select;
  const { Search } = Input;
  const [selectedRow, setSelectedRow] = useState([]);
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [invoiceList, setInvoiceList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [invoiceDate, setInvoiceDate] = useState(null);
  const [dueDate, setDueDate] = useState(null);
  const [totalCount, settotalCount] = useState(0);
  const [reload, setReload] = useState(false);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const intialFilter = {
    driver_id: "",
    invoice_status: "",
    type: "",
    company_id: "",
    company_type: "",
  };

  const [stateFilter, setStateFilter] = useState(intialFilter);
  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
    search: "",
    total: 0,
  });
  useEffect(() => {
    getCompanyList();
  }, []);

  const getCompanyList = async (data) => {
    await getRequest("company/?no_pagination=true", data).then((response) => {
      setCompanyList(response.data.data);
    });
  };
  useEffect(() => {
    const getInvoiceList = async () => {
      setLoading(true);
      const queryParamsObject = {
        ...state,
        invoice_date: invoiceDate || null,
        // due_date: dueDate || null,

        company_id: stateFilter?.company_id || null,
        company_type: stateFilter?.company_type || null,
        invoice_status: stateFilter?.invoice_status || null,

        type: stateFilter?.type || null,
        page: state.page,
        ordering: state.ordering,
        pagesize: state.pagesize,
        search: state.search,
        total: state.total,
      };

      const queryParams = new URLSearchParams(
        Object.entries(queryParamsObject).reduce((acc, [key, value]) => {
          if (value !== null && value !== undefined) {
            acc[key] = value;
          }
          return acc;
        }, {})
      ).toString();

      try {
        let apiResponse = await getRequest(
          `invoice/adjustment-invoice/?${queryParams}`
        );
        if (apiResponse?.data?.results?.success) {
          setInvoiceList(apiResponse?.data?.results?.data);
          settotalCount(apiResponse.data.count);
        } else {
          ErrorNotificationMsg(t("error_in_company_list"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    getInvoiceList();
  }, [state, reload, t]);

  const handleResetFilter = () => {
    setState({
      page: 1,
      ordering: "id",
      pagesize: 10,
      search: "",
      total: 0,
    });
    setStateFilter(intialFilter);
    setInvoiceDate(null);
    setDueDate(null);
    form.setFieldsValue({ search: "" });

    formRef.current.setFieldsValue({
      invoice_date: undefined,
      //   due_date: undefined,
      invoice_status: undefined,
      type: undefined,

      company_type: undefined,
      company: undefined,
    });
  };

  const handlePaymentStatus = (value) => {
    setStateFilter((prevState) => ({
      ...prevState,
      invoice_status: value,
    }));
  };
  const handleCompanyChange = (value) => {
    setStateFilter((prevState) => ({
      ...prevState,
      company_id: value,
    }));
  };
  const handleCompanyTypeChange = (value) => {
    setStateFilter((prevState) => ({
      ...prevState,
      company_type: value,
    }));
  };
  const handlePaymentTypeChange = (value) => {
    setStateFilter((prevState) => ({
      ...prevState,
      type: value,
    }));
  };
  const handleInvoiceDate = (date) => {
    const formattedDate = moment(date).format("DD-MM-YYYY");
    setInvoiceDate(formattedDate);
  };
  const handleDueDateChange = (date) => {
    const formattedDate = moment(date).format("DD-MM-YYYY");
    setDueDate(formattedDate);
  };
  const handleApplyFilter = async () => {
    setState({
      // ...state,
      page: 1,
      ordering: "id",
      pagesize: 10,
      search: "",
      total: 0,
    });
  };
  const handleDownload = async (invoiceId, company_type) => {
    try {
      let apiResponse = await getRequest(`invoice/${invoiceId}`);
      console.log("apiResponse", apiResponse);
      const data = apiResponse.data.data;

      const tempContainer = document.createElement("div");
      document.body.appendChild(tempContainer);

      const invoiceRef = createRef();

      const root = createRoot(tempContainer);

      root.render(<AdjustmentInvoicePdf ref={invoiceRef} data={data} />);

      // Wait for the component to render
      setTimeout(async () => {
        const canvas = await html2canvas(invoiceRef.current);
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

        pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
        pdf.save(`invoice_${data.invoice_number}.pdf`);

        root.unmount();
        document.body.removeChild(tempContainer);
      }, 1000); // small delay to ensure DOM render
    } catch (error) {
      console.error("Error downloading invoice:", error);
    }
  };
  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
    setSelectedRow(selectedRow);
  };

  const handleReset = () => {
    setState({
      ...state,
      search: "",
    });

    form.setFieldsValue({ search: "" });
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";

    if (sortField === "invoice_to_name" && sortOrder === "ascend") {
      sortingEnumKey = "invoice_to_name";
    }
    if (sortField === "invoice_to_name" && sortOrder === "descend") {
      sortingEnumKey = "-invoice_to_name";
    }
    if (sortField === "invoice_status" && sortOrder === "ascend") {
      sortingEnumKey = "invoice_status";
    }
    if (sortField === "invoice_status" && sortOrder === "descend") {
      sortingEnumKey = "-invoice_status";
    }

    if (sortField === "billed_by_legal_name" && sortOrder === "ascend") {
      sortingEnumKey = "billed_by_legal_name";
    }
    if (sortField === "billed_by_legal_name" && sortOrder === "descend") {
      sortingEnumKey = "-billed_by_legal_name";
    }
    if (sortField === "billed_by_business_name" && sortOrder === "ascend") {
      sortingEnumKey = "billed_by_business_name";
    }
    if (sortField === "billed_by_business_name" && sortOrder === "descend") {
      sortingEnumKey = "-billed_by_business_name";
    }
    if (sortField === "billed_by_abn" && sortOrder === "ascend") {
      sortingEnumKey = "billed_by_abn";
    }
    if (sortField === "billed_by_abn" && sortOrder === "descend") {
      sortingEnumKey = "-billed_by_abn";
    }
    if (sortField === "billed_by_email" && sortOrder === "ascend") {
      sortingEnumKey = "billed_by_email";
    }
    if (sortField === "billed_by_email" && sortOrder === "descend") {
      sortingEnumKey = "-billed_by_email";
    }
    if (sortField === "invoice_to_address_line" && sortOrder === "ascend") {
      sortingEnumKey = "invoice_to_address_line";
    }
    if (sortField === "invoice_to_address_line" && sortOrder === "descend") {
      sortingEnumKey = "-invoice_to_address_line";
    }
    if (sortField === "note" && sortOrder === "ascend") {
      sortingEnumKey = "note";
    }
    if (sortField === "note" && sortOrder === "descend") {
      sortingEnumKey = "-note";
    }
    if (sortField === "account_no" && sortOrder === "ascend") {
      sortingEnumKey = "account_no";
    }
    if (sortField === "account_no" && sortOrder === "descend") {
      sortingEnumKey = "-account_no";
    }
    if (sortField === "bank_state_branch" && sortOrder === "ascend") {
      sortingEnumKey = "bank_state_branch";
    }
    if (sortField === "bank_state_branch" && sortOrder === "descend") {
      sortingEnumKey = "-bank_state_branch";
    }

    if (sortField === "company_type" && sortOrder === "ascend") {
      sortingEnumKey = "company__company_type";
    }
    if (sortField === "company_type" && sortOrder === "descend") {
      sortingEnumKey = "-company__company_type";
    }

    if (sortField === "invoice_number" && sortOrder === "ascend") {
      sortingEnumKey = "invoice_number";
    }
    if (sortField === "invoice_number" && sortOrder === "descend") {
      sortingEnumKey = "-invoice_number";
    }

    if (sortField === "invoice_date" && sortOrder === "ascend") {
      sortingEnumKey = "invoice_date";
    }
    if (sortField === "invoice_date" && sortOrder === "descend") {
      sortingEnumKey = "-invoice_date";
    }

    if (sortField === "amount" && sortOrder === "ascend") {
      sortingEnumKey = "amount";
    }
    if (sortField === "amount" && sortOrder === "descend") {
      sortingEnumKey = "-amount";
    }

    // if (sortField === "due_date" && sortOrder === "ascend") {
    //   sortingEnumKey = "due_date";
    // }
    // if (sortField === "due_date" && sortOrder === "descend") {
    //   sortingEnumKey = "-due_date";
    // }

    if (sortField === "invoice_status" && sortOrder === "ascend") {
      sortingEnumKey = "invoice_status";
    }
    if (sortField === "invoice_status" && sortOrder === "descend") {
      sortingEnumKey = "-invoice_status";
    }
    if (sortField === "type" && sortOrder === "ascend") {
      sortingEnumKey = "type";
    }
    if (sortField === "type" && sortOrder === "descend") {
      sortingEnumKey = "-type";
    }

    return sortingEnumKey;
  };

  const handleStatus = async (user_id, status) => {
    confirmAlert({
      title: t("confirmAlert_title"),
      message: t("pop_company_status_message"),
      buttons: [
        {
          label: t("confirmAlert_ok"),
          onClick: () => changeStatus(user_id, status),
        },
        {
          label: t("confirmAlert_cancel"),
          onClick: () => navigate("/invoice-list"),
        },
      ],
    });
  };

  const changeStatus = async (id, value) => {
    setLoading(true);
    await patchRequest(`invoice/${id}/update-invoice-status/`)
      .then((response) => {
        SuccessNotificationMsg(t("status_updated_sucessfully"));
        setReload((reload) => !reload);
      })
      .catch((error) => {
        // Handle error here (e.g., show an error notification)
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const [checkedList, setCheckedList] = useState([
    "invoice_to_name",
    "company_type",
    "invoice_number",
    "invoice_date",
    "amount",
    "type",
    // "due_date",
    "invoice_status",
    "invoice_to_address_line",
    "note",

    "operation",
  ]);
  const [columns, setColumns] = useState([
    {
      title: "Company Name",
      dataIndex: "invoice_to_name",
      key: "invoice_to_name",
      sorter: true,
      width: 100,
      render: (dataIndex) => (
        <div
          style={{
            maxWidth: "400px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            textTransform: "none",
          }}
        >
          {dataIndex}
        </div>
      ),
    },

    {
      title: "Company Type",
      dataIndex: "company_type",
      key: "company_type",
      sorter: true,
      width: 130,
      render: (dataIndex) => (
        <div
          style={{
            maxWidth: "400px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            textTransform: "none",
          }}
        >
          {dataIndex}
        </div>
      ),
    },
    {
      title: "Invoice No.",
      dataIndex: "invoice_number",
      key: "invoice_number",
      sorter: true,
      width: 130,
      render: (dataIndex) => (
        // <Tooltip
        //   color={colors}
        //   placement="left"
        //   title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
        // >
        <div
          style={{
            maxWidth: "400px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {dataIndex}
        </div>
        // </Tooltip>
      ),
    },

    {
      title: "Invoice Date",
      dataIndex: "invoice_date",
      key: "invoice_date",
      width: 180,
      sorter: true,
      render: (date) => date,
    },
    {
      title: "Payment Type",
      dataIndex: "type",
      key: "type",
      width: 180,
      sorter: true,
    },
    {
      title: "Note",
      dataIndex: "note",
      key: "note",
      width: 180,
      sorter: true,
    },

    {
      title: "Amount",
      //   dataIndex: "amount",
      key: "amount",
      sorter: true,
      width: 130,
      render: (i, record) => (
        <div
          style={{
            maxWidth: "400px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {record?.adjustment_amount}
        </div>
      ),
    },
    // {
    //   title: "Due Date",
    //   dataIndex: "due_date",
    //   key: "due_date",
    //   sorter: true,
    //   width: 130,
    // },

    {
      title: "Customer Address",
      dataIndex: "invoice_to_address_line",
      key: "invoice_to_address_line",
      width: 180,
      sorter: true,
    },
    {
      title: "Status",
      dataIndex: "invoice_status",
      key: "invoice_status",
      fixed: "right",
      width: 250,
      render: (e, record) => (
        <div className="SelectStatusSec">
          <Select
            // value={e ? e : record.status}
            //onChange={(e) => handleStatus(record.id, e)}
            defaultValue={e}
            value={e ? e : record.invoice_status}
            onChange={(e) => handleStatus(record.id, e)}
          >
            <Option value="Pending" disabled>
              {" "}
              <div className="discardopt">{t("pending")}</div>
            </Option>
            <Option value="Paid">
              {" "}
              <div className="dealdoneopt">{t("Paid")}</div>
            </Option>
          </Select>
        </div>
      ),
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 100,
      render: (text, record) => (
        <Space>
          {/* <Tooltip title="View Invoice">
            <span
              //   onClick={() =>
              //     handleDownload(
              //       record.id,
              //       record.company_id,
              //       record?.company_type
              //     )
              //   }
              style={{ cursor: "pointer" }}
            >
              <EyeOutlined />
            </span>
          </Tooltip> */}
          <Tooltip title="Download Invoice">
            <span
              className="material-symbols-outlined"
              onClick={() =>
                handleDownload(
                  record.id,

                  record?.company_type
                )
              }
              style={{ cursor: "pointer" }}
            >
              download
            </span>
          </Tooltip>
        </Space>
      ),
    },
  ]);

  useEffect(() => {
    const updatedColumns = columns.map((column) => ({
      ...column,
      hidden: !checkedList.includes(column.key),
    }));
    setColumns(updatedColumns);
  }, [checkedList, columns]);

  const handleColumnVisibilityChange = (checkedValues) => {
    setCheckedList(checkedValues);
  };

  // const columnMenu = (
  //   <Menu>
  //     <Menu.Item>
  //       <Checkbox.Group
  //         value={checkedList}
  //         onChange={handleColumnVisibilityChange}
  //       >
  //         <Row>
  //           <Col span={12}>
  //             <Checkbox value="invoice_to_name">Name</Checkbox>
  //           </Col>
  //           <Col span={12}>
  //             <Checkbox value="company_email">E-mail</Checkbox>
  //           </Col>
  //           <Col span={12}>
  //             <Checkbox value="company_street_address">Address</Checkbox>
  //           </Col>
  //           <Col span={12}>
  //             <Checkbox value="company_number">Contact Number</Checkbox>
  //           </Col>
  //           <Col span={12}>
  //             <Checkbox value="company_contact_name">Contact Name</Checkbox>
  //           </Col>
  //           <Col span={12}>
  //             <Checkbox value="company_abn_no">ABN Number</Checkbox>
  //           </Col>
  //           <Col span={12}>
  //             <Checkbox value="company_note">Note</Checkbox>
  //           </Col>
  //           <Col span={12}>
  //             <Checkbox value="status">Status</Checkbox>
  //           </Col>

  //           <Col span={12}>
  //             <Checkbox value="operation" disabled>
  //               Action
  //             </Checkbox>
  //           </Col>
  //         </Row>
  //       </Checkbox.Group>
  //     </Menu.Item>
  //   </Menu>
  // );

  const allColumns = [
    { key: "invoice_to_name", title: "Company Name" },
    { key: "company_type", title: "Company Type" },
    { key: "invoice_number", title: "Invoice No." },
    { key: "invoice_date", title: "Invoice Date" },
    { key: "type", title: "Payment Type" },
    { key: "amount", title: "Amount" },
    // { key: "due_date", title: "Due Date" },

    { key: "invoice_status", title: "Status" },

    { key: "invoice_to_address_line", title: "Address" },

    { key: "note", title: "Note" },
    { key: "operation", title: "Actions" },
  ];

  const columnMenu = (
    <Menu className="packagelistdropdown">
      <Menu.Item>
        <Checkbox.Group
          value={checkedList}
          onChange={handleColumnVisibilityChange}
        >
          <Row>
            {allColumns.map((column) => (
              <Col span={12} key={column.key}>
                <Checkbox
                  value={column.key}
                  disabled={column.key === "operation"}
                >
                  {column.title}
                </Checkbox>
              </Col>
            ))}
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );

  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };

  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);

  // const rowSelection = {
  //   onSelect: (record, selected, selectedRows) => {
  //     const updatedSelectedRowKeys = selected
  //       ? [...selectedRow, record.id]
  //       : selectedRow.filter((key) => key !== record.id);
  //     setSelectedRow(updatedSelectedRowKeys);
  //   },
  //   onSelectAll: (selected, selectedRows, changeRows) => {
  //     const updatedSelectedRowKeys = selected
  //       ? [...selectedRow, ...changeRows.map((row) => row.id)]
  //       : selectedRow.filter(
  //           (key) => !changeRows.find((row) => row.id === key)
  //         );
  //     setSelectedRow(updatedSelectedRowKeys);
  //   },
  //   selectedRowKeys: selectedRow,
  // };

  const handleArchive = async (id = []) => {
    // let ids = selectedRow;
    // if (ids.length === 0) {
    //   ids.push(id);
    // }
    let ids = [...selectedRow];
    if (ids.length === 0 && id) {
      ids.push(id);
    }
    try {
      let apiResponse = await postRequest("company/archive-company/", {
        deleted: ids,
      });
      if (apiResponse.data.success) {
        let totalArchive = totalCount - ids.length;

        if (totalArchive < 11) {
          setState((prevState) => ({
            ...prevState,
            page: 1,
            search: "",
          }));
          setReload(!reload);
        } else {
          setReload(!reload);
        }
        SuccessNotificationMsg(t("company_archive_successfully"));

        setSelectedRow([]);
      } else {
        setState((prevState) => ({
          ...prevState,
          page: 1,
          search: "",
        }));
      }
    } catch (error) {
      setState((prevState) => ({
        ...prevState,
        page: 1,
        search: "",
      }));
    }
  };

  const handleEdit = (id) => {};
  const downloadCSV = async () => {
    setBtnLoading(true);
    const endpoint = `invoice/invoice-excel-download/`;
    const fileType = "csv";

    // Construct query parameters similar to getEmployeeList
    const queryParamsObject = {
      // ...state,
      invoice_date: invoiceDate || null,
      //   due_date: dueDate || null,
      company_id: stateFilter?.company_id || null,
      company_type: stateFilter?.company_type || null,
      invoice_status: stateFilter?.invoice_status || null,
      type: stateFilter?.type || null,

      transaction_type: "adjustment",
      // page: state.page,
      ordering: state.ordering,
      // pagesize: state.pagesize,
      search: state.search,
      total: state.total,
    };

    const queryParams = new URLSearchParams(
      Object.entries(queryParamsObject).reduce((acc, [key, value]) => {
        if (value !== null && value !== undefined) {
          acc[key] = value;
        }
        return acc;
      }, {})
    ).toString();

    try {
      // Use getRequest with the constructed query parameters
      const response = await getRequest(`${endpoint}?${queryParams}`);

      // Process the response to download the CSV file
      const blob = new Blob([response.data], {
        type: "text/csv",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `InvoiceReport${+new Date()}.${fileType}`;
      link.click();
      setBtnLoading(false);
    } catch (error) {
      setBtnLoading(false);
      if (error.response && error.response.status === 404) {
        console.error("File not found or endpoint is incorrect.");
        setBtnLoading(false);
      } else {
        console.error("Error downloading the file:", error);
        setBtnLoading(false);
      }
    }
  };
  const colors = ["#737373"];
  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            {/* <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  View & manage the list of company within the organization.
                </span>
              }
            > */}
            <h3>{t("Adjustment Invoices")}</h3>
            {/* </Tooltip> */}

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{t("Adjustment Invoices")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Space>
            <div className="searchwrp">
              <Space direction="vertical">
                <Form form={form}>
                  <Form.Item name="search" initialValue="">
                    <Search
                      // value={state.search}
                      prefix={
                        <img
                          src={SearchIcon}
                          alt="SearchIcon"
                          className="SearchIcon"
                          width={22}
                        />
                      }
                      placeholder={t("pl_search_list")}
                      onChange={searchCallbackDelayed}
                    />
                  </Form.Item>
                </Form>
              </Space>
            </div>
            {state?.search ? (
              // <Tooltip title="Reset search">
              <Button
                className="BlueShadowBtn"
                type="primary"
                htmlType="button"
                onClick={() => handleReset()}
              >
                <span
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <UndoOutlined style={{ fontSize: "16px", color: "#fff" }} />{" "}
                  Reset
                </span>
              </Button>
            ) : (
              // </Tooltip>
              ""
            )}
            {/* <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  Add A New Company To The Organization&apos;s Database.
                </span>
              }
            > */}

            {/* </Tooltip> */}

            {/* <Tooltip placement="topLeft" title="Column Filter Options"> */}
            <div className="gridiconswrap">
              <Dropdown
                overlay={columnMenu}
                trigger={["click"]}
                placement="bottomRight"
                visible={dropdownVisible}
                onVisibleChange={(visible) => setDropdownVisible(visible)}
              >
                <Button
                  type="primary"
                  shape="circle"
                  icon={<InsertRowLeftOutlined />}
                  onClick={() => setDropdownVisible(!dropdownVisible)}
                />
              </Dropdown>
            </div>
            {/* </Tooltip> */}
          </Space>
        </div>
      </div>

      <section className="grid-sec">
        <div className="Package-body">
          <div className="filterrow packagefilter">
            <div className="filtercol">
              <Form autoComplete="off" ref={formRef}>
                <Space wrap>
                  <Col
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={24}
                    className="TextFeild gutter-row"
                  >
                    <Form.Item
                      name="invoice_date"
                      label={t("invoice_date")}
                      rules={[
                        {
                          required: false,
                          message: <Trans>{t("val_invoice_date")}</Trans>,
                        },
                      ]}
                    >
                      <DatePicker
                        format="DD-MM-YYYY"
                        allowClear={false}
                        onChange={handleInvoiceDate}
                        style={{ width: "140px" }}
                        placeholder={t("pl_invoice_date")}
                      />
                    </Form.Item>
                  </Col>

                  {/* <Col
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={24}
                    className="TextFeild gutter-row"
                  >
                    <Form.Item
                      name="due_date"
                      label={t("due_date")}
                      rules={[
                        {
                          required: false,
                          message: <Trans>{t("val_due_date")}</Trans>,
                        },
                      ]}
                    >
                      <DatePicker
                        format="DD-MM-YYYY"
                        allowClear={false}
                        onChange={handleDueDateChange}
                        style={{ width: "140px" }}
                        placeholder={t("pl_due_date")}
                      />
                    </Form.Item>
                  </Col> */}

                  <Col
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={24}
                    className="TextFeild gutter-row"
                  >
                    <Form.Item name="company" label={t("pl_company")}>
                      <Select
                        placeholder={t("pl_select_company")}
                        showArrow
                        showSearch
                        name="company"
                        value={state?.company}
                        optionFilterProp="children"
                        onChange={handleCompanyChange}
                      >
                        {companyList.map((company) => (
                          <Option key={company.id} value={company.id}>
                            {company.company_name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={24}
                    className="TextFeild gutter-row"
                  >
                    <Form.Item
                      name="company_type"
                      label={t("label_company_type")}
                    >
                      <Select
                        placeholder={t("pl_select_company_type")}
                        showArrow
                        showSearch
                        name="company_type"
                        value={state?.company_type}
                        optionFilterProp="children"
                        onChange={handleCompanyTypeChange}
                      >
                        <Option key="Pre Paid" value="Pre Paid">
                          Pre Paid
                        </Option>
                        <Option key="Post Paid" value="Post Paid">
                          Post Paid
                        </Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={24}
                    className="TextFeild gutter-row"
                  >
                    <Form.Item name="type" label={t("Payment Type")}>
                      <Select
                        placeholder={t("Select Type")}
                        showArrow
                        showSearch
                        name="type"
                        value={state?.type}
                        optionFilterProp="children"
                        onChange={handlePaymentTypeChange}
                      >
                        <Option key="Credit" value="Credit">
                          Credit
                        </Option>
                        <Option key="Debit" value="Debit">
                          Debit
                        </Option>
                      </Select>
                    </Form.Item>
                  </Col>

                  {/* <Col
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={24}
                    className="TextFeild gutter-row"
                  >
                    <Form.Item
                      name="status"
                      label={t("Status")}
                      value={state?.status}
                    >
                      <Select
                        showArrow
                        placeholder={t("Select Status")}
                        onChange={(value) => handlePaymentStatus(value)}
                      >
                        <Option key="Pending" value="Pending">
                          Pending
                        </Option>
                        <Option key="Paid" value="Paid">
                          Paid
                        </Option>
                      </Select>
                    </Form.Item>
                  </Col> */}
                </Space>
              </Form>
            </div>
            <div className="btnscol btncolpack">
              <Space className="btnpack">
                <>
                  {/* <Tooltip title="Apply Filter"> */}
                  <Button
                    className="SaveGradiantBtn"
                    type="primary"
                    htmlType="Apply"
                    // label="Apply"
                    onClick={handleApplyFilter}
                  >
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <FilterOutlined style={{ fontSize: "16px" }} /> Apply
                      Filter
                    </span>
                  </Button>
                  {/* </Tooltip> */}
                  {invoiceDate ||
                  dueDate ||
                  stateFilter?.invoice_status ||
                  stateFilter?.company_id ||
                  stateFilter?.company_type ||
                  stateFilter?.type ? (
                    // <Tooltip title="Reset Filter">
                    <Button
                      className="SaveGradiantBtn"
                      type="primary"
                      htmlType="Reset"
                      // label="Reset"
                      onClick={handleResetFilter}
                    >
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                        }}
                      >
                        <UndoOutlined
                          style={{ fontSize: "16px", color: "#fff" }}
                        />{" "}
                        Reset
                      </span>
                    </Button>
                  ) : (
                    // </Tooltip>
                    ""
                  )}
                </>
                {/* <Tooltip title="Download CSV"> */}
                <Button
                  className="SaveGradiantBtn"
                  type="primary"
                  htmlType="DownloadPDF"
                  // label="Download CSV"
                  onClick={downloadCSV}
                  loading={btnLoading}
                >
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <DownloadOutlined style={{ fontSize: "16px" }} /> Download
                    CSV
                  </span>
                </Button>
                {/* </Tooltip> */}
              </Space>
            </div>
          </div>
          <Table
            // className="fixedcol"
            // rowSelection={rowSelection}
            columns={columns.filter((col) => !col.hidden)}
            rowKey={(record) => record.id}
            dataSource={invoiceList}
            loading={loading}
            pagination={{
              defaultCurrent: state.page,
              defaultPageSize: state.pagesize,
              total: totalCount,
              showTotal: (total) => `Total ${total} items`,
              showSizeChanger: true,
              locale: {
                items_per_page: "Items / Page",
              },
            }}
            onChange={handleTableChange}
            scroll={{
              x: 1000,
            }}
          />
        </div>
      </section>
    </>
  );
};
export default AdjustmentListAdmin;
